<section
    role="region"
    aria-label="Booking hub"
    class="w-full h-full bp908:h-auto bg-p-content-background rounded-t-2xl bp908:rounded-2xl p-4 bp908:shadow-p-form-field-shadow bp908:border bp908:border-p-content-border-color">
    <div class="max-h-full min-h-0 w-full flex flex-col gap-4">
        @if (showFocusNowForm) {
            <div class="w-full flex flex-col justify-start items-start order-2 gap-4">
                <div class="h-12 w-full flex items-center justify-between">
                    <div
                        class="mr-auto text-color text-16 font-semibold font-inter animation-slide-left-and-fade-in-quick"
                        >Focus now</div
                    >

                    <p-button
                        [buttonProps]="{ autofocus: false }"
                        severity="secondary"
                        [outlined]="true"
                        (click)="onClickCloseFocusNowForm()"
                        icon="pi pi-times"
                        styleClass="aspect-square"
                        size="small" />
                </div>
                @if (viewportService.isMobile()) {
                    <div class="w-full h-[1px] border-b border-p-content-border-color"></div>
                }
            </div>
        } @else if (showScheduleForm) {
            <div class="w-full flex flex-col justify-start items-start order-2 gap-4">
                <div class="h-12 w-full flex items-center justify-between">
                    <div
                        class="mr-auto text-color text-16 font-semibold font-inter animation-slide-left-and-fade-in-quick"
                        >Book session</div
                    >
                    <p-button
                        [buttonProps]="{ autofocus: false }"
                        severity="secondary"
                        [outlined]="true"
                        (click)="onClickCloseScheduleForm()"
                        icon="pi pi-times"
                        styleClass="aspect-square"
                        size="small"
                        aria-label="Close schedule form" />
                </div>
                @if (viewportService.isMobile()) {
                    <div class="w-full h-[1px] border-b border-p-content-border-color"></div>
                }
            </div>
        }

        @if (
            !showScheduleForm &&
            !showFocusNowForm &&
            !(viewportService.isMobile() && !settingsExpanded)
        ) {
            <div
                class="flex flex-col items-center justify-center w-full gap-4 order-4 bp908:order-3">
                @if (viewportService.isMobile()) {
                    <div class="w-full h-[1px] border-b border-p-content-border-color"></div>
                }

                <div class="flex flex-row items-center justify-center w-full gap-[1px]">
                    @if (nowSessionsAvailable) {
                        <p-button
                            [buttonProps]="{ autofocus: false }"
                            #focusNowButton
                            severity="primary"
                            size="large"
                            label="Book"
                            class="fm-button-xlarge flex-1 animation-slide-right-and-fade-in-quick"
                            styleClass="w-full !rounded-r-none"
                            (click)="onClickShowScheduleForm()">
                            <ng-template #icon>
                                <fa-icon [icon]="faClock" />
                            </ng-template>
                        </p-button>

                        <p-button
                            [buttonProps]="{ autofocus: false }"
                            #scheduleButton
                            pTooltip="Instant 50-min session"
                            showDelay="1000"
                            tooltipPosition="right"
                            severity="primary"
                            size="large"
                            label="Now"
                            class="fm-button-xlarge flex-1 animation-slide-right-and-fade-in-quick"
                            styleClass="w-full !rounded-l-none"
                            (click)="onClickShowFocusNowForm()">
                            <ng-template #icon>
                                <fa-icon [icon]="faBolt" />
                            </ng-template>
                        </p-button>
                    } @else {
                        <p-button
                            [buttonProps]="{ autofocus: false }"
                            #scheduleButton
                            severity="primary"
                            size="large"
                            label="Book session"
                            class="fm-button-xlarge w-full animation-slide-right-and-fade-in-quick"
                            styleClass="w-full"
                            (click)="onClickShowScheduleForm()" />
                    }
                </div>
            </div>
        }

        @if (!viewportService.isMobile()) {
            <div
                class="w-[calc(100%+32px)] h-[1px] border-b order-4 bp908:order-3 border-p-content-border-color ml-[-16px]"></div>
        }

        <div #container class="w-full order-3 bp908:order-5 animate-height-snappy bp908:self-end">
            @if (!showFocusNowForm) {
                <div class="w-full animation-fade-in">
                    <fm-booking-hub-session-settings
                        (settingsExpanded)="onSettingsExpandedToggle($event)" />
                </div>
            }

            @if (showScheduleForm) {
                <div class="w-full mt-3 animation-fade-in">
                    <fm-booking-hub-schedule-form
                        (onBookingCompleted)="onClickCloseScheduleForm()" />
                </div>
            }

            @if (showFocusNowForm) {
                <div class="w-full mt-2 animation-fade-in">
                    <fm-now-sessions-sidebar (onBookingCompleted)="onClickCloseFocusNowForm()" />
                </div>
            }
        </div>
    </div>
</section>
